import { navigation } from '../../utilities/navigation';
import { FontAwesomeIcon } from '../FontAwesomeIcon';

const SocialMediaNav = () => {
    const { socialMedia } = navigation;
    return (
        <ul className='d-flex justify-content-between ps-3' style={{ width: '140px' }}>
            {socialMedia.map((item, i) => (
                <li key={i} className='circle-btn'>
                    <a
                        href={item.link}
                        aria-label={`go to ${item.label}`}
                        target='_blank'
                        rel='noreferrer noopener'
                    >
                        <FontAwesomeIcon icon={item.icon} className='fa-lg' />
                    </a>
                </li>
            ))}
        </ul>
    );
};

export default SocialMediaNav;
